import moment from 'moment';
import Checkbox from '~/components/checkbox';
import ContainerFlex from '~/components/containerFlex';
import {
  Lancamento,
  ReprocessamentoFaturaDados,
} from '~/models/reprocessamento-fatura';
import { currencyMask } from '~/utils/masks';
import { useInvoiceReprocess } from '../../context';
import * as St from './styles';

const formatter = new Intl.NumberFormat('pt-BR', {
  currency: 'BRL',
  minimumFractionDigits: 2,
  style: 'currency',
});
interface TransactionTable {
  data: ReprocessamentoFaturaDados;
  readOnly?: boolean;
  resumedView?: boolean;
}
export default function TransactionTable({
  data,
  readOnly = false,
  resumedView = false,
}: TransactionTable) {
  const lancamentos = data?.lancamentos;
  const { selectedItems, setSelectedItemsByInvoice } = useInvoiceReprocess();
  const currentSelectedItems = selectedItems?.[data.idFatura] || [];

  const totalToRemove = () => {
    if (readOnly) {
      return data.lancamentos
        .filter((l) => l.remover)
        ?.reduce((acc, curr) => {
          return acc + curr?.valor;
        }, 0);
    }
    return currentSelectedItems?.reduce((acc, curr) => {
      return acc + curr?.valor;
    }, 0);
  };
  const totalAfterRemove = data.valorFatura - totalToRemove();
  const renderCheckboxTableCell = (
    item: Lancamento,
    isItemSelected: boolean,
  ) => {
    if (resumedView || readOnly) {
      return null;
    }
    if (item.remover) {
      return (
        <St.Td>
          <Checkbox value={item.remover} auto readonly />
        </St.Td>
      );
    }

    if (!item.checkbox) {
      return <St.Td />;
    }
    return (
      <St.Td>
        <Checkbox
          value={isItemSelected}
          onChangeStatus={(v) => {
            setSelectedItemsByInvoice(data.idFatura, item);
          }}
        />
      </St.Td>
    );
  };
  const getRowStyle = (item: Lancamento, isItemSelected: boolean) => {
    let color = '#4a4b4a';
    if (resumedView || readOnly) {
      if (isItemSelected || item.remover) {
        color = '#e71037';
      }
    }
    return { color };
  };
  console.log({ resumedView, readOnly });
  return (
    <>
      <ContainerFlex
        style={{ minHeight: '500px', maxHeight: '100%', overflowY: 'auto' }}
      >
        <St.Table>
          <St.Thead>
            <tr>
              {resumedView || readOnly ? null : <St.Th></St.Th>}

              <St.Th>Lançamento</St.Th>
              <St.Th>Tipo</St.Th>
              <St.Th>Valor</St.Th>
              <St.Th>Data</St.Th>
            </tr>
          </St.Thead>
          <tbody>
            {lancamentos?.map((item) => {
              const isSelected = currentSelectedItems?.includes(item);

              return (
                <St.Tr
                  key={item.idTransacao}
                  style={getRowStyle(item, isSelected)}
                >
                  {renderCheckboxTableCell(item, isSelected)}

                  <St.Td>{item.descricao}</St.Td>
                  <St.Td>{item.tipo}</St.Td>
                  <St.Td>{currencyMask(item.valor)}</St.Td>
                  <St.Td>{moment(item.data).format('DD/MM/YYYY')}</St.Td>
                </St.Tr>
              );
            })}
          </tbody>
        </St.Table>
      </ContainerFlex>
      <St.BoxCardResume>
        <p>Resumo financeiro</p>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <div className="content">
            <span>Valor original</span>
            <b>{formatter.format(data.valorFatura)}</b>
          </div>
          <div className="content">
            <span>Total a remover</span>
            <b style={{ color: '#af0b2b' }}>
              {formatter.format(totalToRemove())}
            </b>
          </div>
          <div className="content">
            <span>Novo valor estimado</span>
            <b style={{ color: '#2B964F' }}>
              {formatter.format(totalAfterRemove)}
            </b>
          </div>
        </div>
      </St.BoxCardResume>
    </>
  );
}
